export const SET_ALERT_DATA = 'SET_ALERT_DATA';

export const setAlertData = (alertData) => {
  return {
    type: SET_ALERT_DATA,
    data: alertData,
  };
};
